<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="mb-5  background_color" >
                <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicles </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/mmodels/index"> Manage Vehicle  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Vehicle  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div  class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2">
  <div  class="card-body custom_bdr_rds">



                    <form @submit.prevent="SaveModels()" >


<div class="row">
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">HS Code</label>
            <input type="date" v-model="models.hs_code"   style="font-size: small;" class="form-control" required>
            <!-- <v-select class="font-size_def" label="label"  @input="loadcontact"  v-model="squatation.idcustomer"  :options="mcustomers" :class="{'is-invalid': errors.idCustomerError}"></v-select>
            <div class="invalid-feedback">
              {{ errors.idCustomerError }}
            </div> -->
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Category</label>
            <input type="date" v-model="models.category"   style="font-size: small;" class="form-control" required>
    </div>
  </div>
  
 
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Country </label>
              <v-select class="font-size_def" label="countryname"   v-model="models.country"  :options="countries" ></v-select>
           
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Year of Manufacture</label>
            <input v-model="models.year"   style="font-size: small;" class="form-control" required>
    </div>
  </div>
</div>



<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Engine</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Brand Name </label>
              <v-select class="font-size_def" label="brand_name"   v-model="models.brand_name"  :options="mbrands" ></v-select>
           
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Model Name</label>
            <input v-model="models.modelname"   style="font-size: small;" class="form-control" required>
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Model Name for MTA2</label>
            <input v-model="models.mta2modelname"   style="font-size: small;" class="form-control" required>
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Engine</label>
            <input v-model="models.engine"   style="font-size: small;" class="form-control" required>
    </div>
    </div>

</div>

<div class="row">

    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Horse Power </label>
              <v-select class="font-size_def" label="label"   v-model="models.hp"  :options="mcustomers" ></v-select>
           
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Type</label>
            <input v-model="models.type"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Cylinder Capacity</label>
            <input v-model="models.cylinder_capacity"   style="font-size: small;" class="form-control" required>
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Rated Output</label>
            <input v-model="models.rated_op"   style="font-size: small;" class="form-control">
    </div>
    </div>

</div>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Max Output</label>
            <input v-model="models.max_op"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Fuel </label>
              <v-select class="font-size_def" label="label"   v-model="models.fuel"  :options="fuels" ></v-select>
           
    </div>
    </div>
   
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Cooling System</label>
            <input v-model="models.cooling_system"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    

</div>



</div>
</div>


<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Transmission</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Power Transmission System </label>
            <input v-model="models.pts"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Brake</label>
            <input v-model="models.break"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Main Clutch</label>
            <input v-model="models.main_clutch"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Steering Clutch</label>
            <input v-model="models.steering_clutch"   style="font-size: small;" class="form-control">
    </div>
    </div>

</div>



</div>
</div>



<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Road Speed Km/Hr</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Forward Speed</label>
            <input v-model="models.f_speed"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Reverse Speed</label>
            <input v-model="models.r_speed"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Tilling Speed</label>
            <input v-model="models.t_speed"   style="font-size: small;" class="form-control" >
    </div>
    </div>
   

</div>



</div>
</div>


<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Capacities (l)</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Full Tank Capacity</label>
            <input v-model="models.full_tank_capacity"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Starting System</label>
            <input v-model="models.starting_system"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Electrical System</label>
            <input v-model="models.electical_system"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Lamp</label>
            <input v-model="models.lamp"   style="font-size: small;" class="form-control" >
    </div>
    </div>
   

</div>



</div>
</div>


<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Wheels</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Wheels</label>
            <input v-model="models.full_tank_capacity"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Wheels Tread</label>
            <input v-model="models.starting_system"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Wheel Base</label>
            <input v-model="models.electical_system"   style="font-size: small;" class="form-control" >
    </div>
    </div>


</div>


</div>
</div>


<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Tyre Size</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Tyre Size Front</label>
            <input v-model="models.f_tyre_size"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Front D/S</label>
            <v-select class="font-size_def" label="label"   v-model="models.f_ds"  :options="dis" ></v-select>
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Tyre Size Rear</label>
            <input v-model="models.r_tyre_size"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Rear D/S</label>
            <input v-model="models.r_ds"   style="font-size: small;" class="form-control" >
    </div>
    </div>


</div>
<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">B Type</label>
            <v-select class="font-size_def" label="label"   v-model="models.b_type"  :options="dis" ></v-select>
        
    </div>
    </div>

</div>


</div>
</div>


<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Dimemsons (cm)</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Length (cm)</label>
            <input v-model="models.length"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Width (cm)</label>
            <input v-model="models.width"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Height (cm)</label>
            <input v-model="models.height"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Tilling Width and No. of blades</label>
            <input v-model="models.tillingw_blades"   style="font-size: small;" class="form-control" >
    </div>
    </div>


</div>


</div>
</div>


<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Weight</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Weight</label>
            <input v-model="models.w_unit"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Weight Unit</label>
            <v-select class="font-size_def" label="label"   v-model="models.weight"  :options="units" ></v-select>
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Weight (without engine)</label>
            <input v-model="models.grw"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Gross Weight Unit</label>
            <v-select class="font-size_def" label="label"   v-model="models.gw_unit"  :options="units" ></v-select>
    </div>
    </div>


</div>
<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Pay Load</label>
            <input v-model="models.py_load"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Pay Load Unit</label>
            <v-select class="font-size_def" label="label"   v-model="models.upy_load"  :options="units" ></v-select>
        
    </div>
    </div>

</div>


</div>
</div>


<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Other</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Show Inquiry</label>
            <input v-model="models.show_inquiry"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Class Of Vehicle</label>
            <input v-model="models.classOfVehicleId"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Photo Type</label>
            <input v-model="models.phototype"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Seating Capacity</label>
            <input v-model="models.seating"   style="font-size: small;" class="form-control" >
    </div>
    </div>


</div>
<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Driving Side</label>
            <v-select class="font-size_def" label="label"   v-model="models.driving_side"  :options="driveSides" ></v-select>
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Options</label>
            <textarea v-model="models.options" class="form-control" rows="2"></textarea>
           
        
    </div>
    </div>

</div>


</div>
</div>


<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Price Details</b></h6>

<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Price (Without Additional Charges)</label>
            <input v-model="models.price"   style="font-size: small;" class="form-control">
        
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Dealer Commission</label>
            <input v-model="models.dealer_commission"   style="font-size: small;" class="form-control">
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Transport</label>
            <input v-model="models.transport"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">RMV Charge</label>
            <input v-model="models.registration"   style="font-size: small;" class="form-control" >
    </div>
    </div>


</div>
<div class="row">

    <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Insuarance Fee</label>
            <input v-model="models.insuarancefee"   style="font-size: small;" class="form-control" >
    </div>
    </div>
    

</div>


</div>
</div>








    

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
                <br><br>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadAlldata();
    this.loadCustomer();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        qty:0,
        mcustomers:[],
        countries:[],
        mproducts:[],
        contacts:[],
      salespeoples:[

      ],
      errors: {},
      models: {},
     
      squatation:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
        mbrands:[],
        detail:[
      {},  
      ],
      infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
      infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },

        dis: [
            { label: 'Single', value: 'Single' },
            { label: 'Dual', value: 'Dual' },
           
            // Add more options as needed
        ],
        units: [
            { label: 'Kg', value: 'Kg' },
            { label: 'Ton', value: 'Ton' },
           
            // Add more options as needed
        ],
        driveSides: [
            { label: 'Righthand', value: 'Righthand' },
            { label: 'Lefthand', value: 'Lefthand' },
           
            // Add more options as needed
        ],
        fuels: [
           
            { label: 'Petrol', value: 'Petrol' },
            { label: 'Diesel', value: 'Diesel' },
            { label: 'Gas', value: 'Gas' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

      

          async loadAlldata() {
       
     
      try {
        const { data} = await  axios.get('/mmodels/loaddata',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.countries = data.countries;
         this.mbrands = data.mbrands;
        
      } catch (error) {
        console.log(error.response);
      }
    },

    
    

     


   

     async calculateqty(id) {
      
     if(!this.detail[id].line_discount){
      this.detail[id].line_discount = 0;
     } 
    
     if(parseFloat(this.detail[id].avlqty) < parseFloat(this.detail[id].qty)){
      alert("You are not allowed enter more than remaining qty")
      this.$set(this.detail[id], 'qty', this.detail[id].avlqty);

      
     }
  const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100).toFixed(2);
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total1 = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total1 = gpMrg_total1 + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

  }

  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total1.toFixed(2);

  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);
  
     },

     async calculatediscount(id) {
     if(!this.detail[id].qty){
      this.detail[id].qty = 0;
     } 
  const line_amount = this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100;
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

 
 
  }
  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total.toFixed(2);
  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);

     },


     async calculatelinamt(id) {

      const discount = (100 - ((this.detail[id].line_amount*100)/(this.detail[id].price*this.detail[id].qty))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', discount);

      const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      const gpMrgPre = (gpMrg/this.detail[id].line_amount*100).toFixed(2);
      this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },

     async calculategpmarg(id) {
      
       const dis = (100-((parseFloat(this.detail[id].gp_margin / this.detail[id].qty) + parseFloat(this.detail[id].ave_cost))*100/this.detail[id].price)).toFixed(2);
        this.$set(this.detail[id], 'line_discount', dis);


        const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrgPre = (this.detail[id].gp_margin/line_amount*100).toFixed(2);
        this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);


     },

     async calculategppre(id) {

      const dis =  (100 -(this.detail[id].ave_cost*10000/((this.detail[id].price)*(100-this.detail[id].gp_margin_precentage)))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', dis);

      const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },



     async spe_dis() {
        const total = this.subtotal - this.quotation.special_discount;
        this.final_total = total.toFixed(2);
     },

     validate(){
      this.errors = {};
      if(this.squatation.idcustomer == null){
        this.$set(this.errors, 'idCustomerError', "Customer field is required");
      }
      if(this.squatation.customer_contact == null){
        this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      }
      if(this.sales == null){
        this.$set(this.errors, 'salespeoplesError', "Sales Person field is required");
      }
      if(this.quotation.id_brand == null){
        this.$set(this.errors, 'idbrandError', "Brand field is required");
      }
     },

    async SaveModels() {
     
      
console.log("amia");
     
        try {
         const { data} = await  axios.post('/mmodels/create',{userid:this.userid,models:this.models},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
         
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     
       
      
 
      
     },
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    